<template>
    <div class="bto-sb-event-odds">
        <div class="bto-sb-event-odds-right">
            <div v-if="$parent.showEventCode" class="bto-sb-event-code">{{match.eventCode}}</div>
            <div class="bto-sb-event-time">
                <span class="bto-sb-event-inntime">{{match.time}}</span>
                <span class="bto-sb-event-inndate">{{match.date}}</span>
            </div>
            <div :class="['bto-sb-event-odds-info-cell',
      {'bto-sb-event-odds-info-cell-m' : ($parent.showFavorites ? !$parent.showStatistics : $parent.showStatistics)},
      {'bto-sb-dp-none' : (!$parent.showFavorites && !$parent.showStatistics)}
    ]">
                <favorite-component v-if="$parent.showFavorites" :match="match"/>
                <statistics-component v-if="$parent.showStatistics" :betRadarId="match.betRadarId" :feedProvider="match.feedProvider" :isAwayAtHome="match.awayAtHome" :isLive="match.isLiveMatch" :sportId="match.sportId" :tournamentName="match.tournamentName"/>
            </div>
            <div class="bto-sb-event-odds-cell bto-sb-event-odds-cell-description">
                <match-expanded-odd-component
                        v-bind:item="match"
                        v-bind:odd="$parent.firstCol"
                        v-bind:outcome="$parent.firstCol.outcomes[0]"
                        v-bind:isPrematch="true"
                        v-bind:teamIcon="$parent.showTeamIcon ? match.homeTeamIcon : ''"
                        v-bind:eventDescription="$parent.eventDescription"
                        v-bind:teamName="match.homeTeam"
                />
                <match-expanded-odd-component
                        v-if="$parent.firstCol.outcomes.length > 2"
                        v-bind:item="match"
                        v-bind:odd="$parent.firstCol"
                        v-bind:outcome="$parent.firstCol.outcomes[1]"
                        v-bind:isPrematch="true"
                        v-bind:isDraw="true"
                />
                <match-expanded-odd-component
                        v-bind:item="match"
                        v-bind:odd="$parent.firstCol"
                        v-bind:outcome="$parent.firstCol.outcomes.length > 2 ? $parent.firstCol.outcomes[2] : $parent.firstCol.outcomes[1]"
                        v-bind:isPrematch="true"
                        v-bind:teamIcon="$parent.showTeamIcon ? match.guestTeamIcon : ''"
                        v-bind:eventDescription="$parent.eventDescription"
                        v-bind:teamName="match.guestTeam"
                />
            </div>
            <a class="bto-sb-event-odds-cell bto-sb-event-more-odd"
               :class="{
                   'bto-sb-event-more-odd-active' : $parent.matchExpanded === true,
                   'bto-sb-event-more-cash' : $parent.cashOutVisibility }"
               @click="$parent.toggleDetails()">
                +{{$parent.SHOW_NUMBER_OF_MARKETS ? match.numberOfMarkets : match.numberOfOdds}}
                <i class="bto-app-cash" v-if="$parent.cashOutVisibility"></i>
            </a>
        </div>
        <embeded-match-details
                v-if="$parent.matchExpanded"
                :matchIdProp="match.matchId"
                :matchTypeProp="match.isLiveMatch ? 'live' : 'prematch'"
                :latamLayout="useLatam"
                @toggleDetails="$emit('toggleDetails')"
        />
    </div>
</template>
<script>
  import MatchListProps from '../match-list-props';

  export default {
    name: 'MatchListItemLatamTpl',
    props: MatchListProps
  };
</script>